import { formatNumber } from './formatNumber';
import { NBSP } from '../../constants/symbols';

export function formatMoney(money: number): string {
  return `${formatNumber(money)}${NBSP}₽`;
}
